import { useEffect, useState } from "react";
import isEmpty from "lodash/isEmpty";

const useVintage = ({ features }) => {
	const [vintage, setVintage] = useState("");

	useEffect(() => {
		if (isEmpty(features)) return;

		const _vintage = features?.find(({ identifier }) => identifier === "vintage")?.value;

		if (_vintage) setVintage(_vintage);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [JSON.stringify(features)]);

	return vintage;
};

export default useVintage;
